import { render } from "./IconChevron.vue?vue&type=template&id=e571949c"
const script = {}
script.render = render

export default script